export const CompanyItems = [
  {
    image: "images/companias/camesa.png",
    alt: "Camesa",
    class:"logo1"
  },
  {
    image: "images/companias/cemex.png",
    alt: "cemex",
    class:"logo2"
  },
  {
    image: "images/companias/clarios.png",
    alt: "Clarios",
    class:"logo1"
  },
  {
    image: "images/companias/cruz_azul.png",
    alt: "Cementos Cruz Azul",
    class:"logo2"
  },
  {
    image: "images/companias/deacero.png",
    alt: "Deacero",
    class:"logo1"
  },
  {
    image: "images/companias/fortaleza.png",
    alt: "Cementos Fortaleza",
    class:"logo3"
  },
  {
    image: "images/companias/gcc.png",
    alt: "GCC",
    class:"logo1"
  },
  {
    image: "images/companias/gerdau.png",
    alt: "Gerdau Corsa",
    class:"logo1"
  },
  {
    image: "images/companias/mexicana_cobre.png",
    alt: "Mexicana de Cobre",
    class:"logo1"
  },
  {
    image: "images/companias/moctezuma.png",
    alt: "Cementos Moctezuma",
    class:"logo2"
  },
  {
    image: "images/companias/ohl.png",
    alt: "OHL",
    class:"logo1"
  },
  {
    image: "images/companias/owen.png",
    alt: "Owens",
    class:"logo1"
  }
  ,
  {
    image: "images/companias/saintgobain.png",
    alt: "Saint Gobain",
    class:"logo1"
  },
  {
    image: "images/companias/tamsa.png",
    alt: "Tenaris Tamsa",
    class:"logo2"
  },
  {
    image: "images/companias/ternium.png",
    alt: "Ternium",
    class:"logo1"
  },
  {
    image: "images/companias/vesuvius.png",
    alt: "Vesuvius",
    class:"logo1"
  },
  {
    image: "images/companias/vitro.png",
    alt: "Vitro",
    class:"logo1"
  }

]
